import React, { Component } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import DesignResourcesPanel from '../designResourcesPanel';
import { getCookie, getAccessToken } from '../../utils/auth';
import { Alert, Form, FormControl, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const PageSize = 15;

class ImageMakerPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            images: [],
            hasNext: true,
            page: 1,
            creditBalance: 0,
            prompt: '',
            alert: { type: '', title: '', isShow: false, desc: '' },
            isImagemakerOpen: false,
            isLoading: false,
        }
    }

    componentDidMount() {
        this.fetchData();
        this.fetchCreditBalance()
    }

    setErrorAlert = (title, desc = '') => {
        this.setState({ alert: { type: 'danger', title, isShow: true, desc } })
    }

    setSuccessAlert = (title, desc = '') => {
        this.setState({ alert: { type: 'success', title, isShow: true, desc } })
    }

    closeAlert = () => {
        this.setState({ alert: { type: '', title: '', isShow: false, desc: '' } })
    }

    fetchHistory = async () => {
        const daitkn = await getAccessToken()
        if (daitkn) {
            const url = `${global.config.server_path}imagemaker/history?perPage=${PageSize}&page=${this.state.page}`
            return fetch(url, { headers: { 'Authorization': daitkn } })
                .then(resp => {
                    if (!resp.ok) {
                        return resp.text().then(t => { throw new Error(t) })
                    }
                    else {
                        return resp.json()
                    }
                })
                .then(({ data, pagination: { page, totalPages } }) => {
                    this.setState({ hasNext: totalPages > page })
                    return data.filter(({ images }) => images.length > 0).map(({ images, userPrompt, id }) => {
                        return {
                            id_imagemaker: id,
                            description: userPrompt,
                            thumbnail: images[0].imageUrl,
                        };
                    });
                }).catch((e) => {
                    this.setErrorAlert('Error fetching your data', JSON.parse(e.message).message || '')
                    return []
                })
        } else {
            this.setErrorAlert('Login to continue..', 'Please login to enjoy this feature')
        }
        return new Promise(res => res([]))
    };

    fetchCreditBalance = async () => {
        const daitkn = await getAccessToken()
        if (daitkn) {
            const url = `${global.config.server_path}imagemaker/auth/userBalance`
            fetch(url, { headers: { 'Authorization': daitkn } })
                .then(resp => resp.json())
                .then(({ balance = 0 }) => {
                    this.setState({ creditBalance: balance })
                }).catch(() => {
                    // this.setErrorAlert('Error fetching your data')
                })
        } else {
            this.setErrorAlert('Login to continue..', 'Please login to enjoy this feature')
        }
    };

    generateImage = async () => {
        const daitkn = await getAccessToken()
        if (daitkn) {
            this.setState({ isLoading: true })
            const url = `${global.config.server_path}imagemaker/text-to-image/generate`
            fetch(url, {
                headers: { 'Authorization': daitkn, 'Content-Type': 'application/json' },
                method: 'POST',
                body: JSON.stringify({ prompt: `${this.props.systemPrompt || ''} ${this.state.prompt}`, model: 'prodiaFluxSchnell' })
            })
                .then(resp => {
                    if (!resp.ok) {
                        return resp.text().then(text => { throw new Error(text) })
                    }
                    else {
                        return resp.json();
                    }
                })
                .then(({ data: { images, userPrompt, id } }) => {
                    this.setState({
                        images: [{
                            id_imagemaker: id,
                            description: userPrompt,
                            thumbnail: images[0].imageUrl,
                        }, ...this.state.images]
                    })
                    this.fetchCreditBalance()
                }).catch((e) => {
                    this.setErrorAlert('Error generating your image', JSON.parse(e.message).message || '')
                }).finally(() => {
                    this.setState({ isLoading: false })
                })
        } else {
            this.setErrorAlert('Login to continue', 'Please login to enjoy this feature')
        }
    };

    fetchData = () => {
        this.fetchHistory().then((data) => {
            this.setState({
                images: this.state.images.concat(data),
                page: this.state.page + 1
            })
        })
    };

    handleGenerateImage = (e) => {
        if (e) {
            e.preventDefault();
            if (!this.state.prompt.length > 0) return this.setErrorAlert('Please provide some description of your desired image')
            if (!this.state.creditBalance > 0) return this.setErrorAlert('It seems you\'re out of credit', 'To keep enjoying uninterrupted service, please update your plan')
            this.generateImage()
        }
    };

    handleSearchOnChange = (e) => {
        this.setState({
            prompt: e.target.value
        })
    };

    handleToggleOpenIM = () => {
        this.setState({ isImagemakerOpen: !this.state.isImagemakerOpen })
    }

    handleToggleOpenIM = () => {
        this.setState({ isImagemakerOpen: !this.state.isImagemakerOpen })
    }

    handleSearchClear = () => {
        this.setState({
            prompt: '',
        })
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.state.alert.title.length > 0 && this.state.alert.isShow &&
                    <div style={{ position: 'relative', zIndex: 200 }}>
                        <Alert style={{ position: 'absolute', width: '100%' }} bsStyle={this.state.alert.type} onDismiss={this.closeAlert} >
                            <h6>{this.state.alert.title}</h6>
                            {this.state.alert.desc && <p style={{ fontSize: '12px', fontStyle: 'italic' }}>{this.state.alert.desc}</p>}
                        </Alert>
                    </div>
                }
                {
                    this.state.isImagemakerOpen ?
                        <div className="nav_content_search_container" style={{ padding: 12 }}>
                            <div style={{ width: '100%', textAlign: 'end' }}>
                                <OverlayTrigger placement="left"
                                    overlay={<Tooltip id="tooltip">AI Credit Balance </Tooltip>}
                                >
                                    <span className="fas fa-coins fas-light" style={{ marginRight: 3 }} />
                                </OverlayTrigger>
                                <span>{this.state.creditBalance}</span>
                            </div>
                            <Form style={{ position: 'relative' }} onSubmit={this.handleGenerateImage}>
                                {
                                    this.state.prompt !== '' &&
                                    <span onClick={this.handleSearchClear} className="btn fas fa-times fas-light fa-sm" style={{ padding: 3, margin: 3, position: 'absolute', right: 0, color: '#C8CDD4' }} />
                                }
                                <FormControl
                                    componentClass="textarea"
                                    rows={3}
                                    bsSize="sm"
                                    required
                                    style={{ fontFamily: 'Montserrat', borderRadius: 4, width: "100%", resize: 'none' }}
                                    placeholder="Describe the image you looking for here"
                                    type="text"
                                    value={this.state.prompt}
                                    onChange={(e) => this.handleSearchOnChange(e)}
                                    title='Please describe the image you looking for'
                                />
                                <Button style={{ marginTop: 2 }} disabled={this.state.prompt === '' || this.state.alert.isShow || this.state.isLoading} className="btn btn-sm btn-block btn-orange" bsSize='xs' type='submit'>Generate (1 credit)</Button>
                            </Form>
                        </div>
                        :
                        <div onClick={this.handleToggleOpenIM} style={{ color: 'orange' }}  >
                            <span style={{ cursor: 'pointer', fontSize: 22, border: '1px orange solid', padding: 6, borderRadius: 4, marginTop: 12 }} className=" btn fas fa-plus fa-2x fas-light" /><br />
                            <span>Generate</span>
                        </div>

                }
                <InfiniteScroll
                    dataLength={this.state.images ? this.state.images.length : 0}
                    next={this.fetchData}
                    hasMore={this.state.hasNext}
                    height={'calc(100vh - 270px)'}
                    endMessage={this.state.images.length > 0 && <h4>No more results.</h4>}
                >
                    {
                        this.state.images.length > 0 ?
                            <p style={{ fontSize: '12px', fontStyle: 'italic', paddingTop: '10px' }}>
                                Powered by <a target='_blank' href="/imagemaker/start/history">ImageMaker</a>
                            </p>
                            : !this.state.alert.isShow && <p style={{ marginTop: 10 }}>No photo. Click Generate to start</p>
                    }
                    {
                        this.state.isLoading &&
                        <span className="fas fa-spinner fa-spin fas-light fa-lg" style={{ padding: 3, margin: 3 }} />
                    }
                    <DesignResourcesPanel
                        on_drag_start={this.props.on_drag_start}
                        on_drag={this.props.on_drag}
                        on_drag_end={this.props.on_drag_end}
                        on_click={this.props.on_click}
                        image_height={'126px'}
                        col_size={6}
                        resources={this.state.images} />

                </InfiniteScroll>
            </React.Fragment>
        );
    }
}

export default ImageMakerPanel;